import { Component, Input } from "@angular/core";

type SKUType = "Keep" | "Grow" | "DTP" | "Delist" | "Accelerate" | "Optimize";

interface SKUData {
  count: number;
  percent: number;
}

interface PortfolioHealthData extends Record<SKUType, SKUData> {
  total: number;
  health: number;
}

@Component({
  selector: "app-portfolio-health-index",
  templateUrl: "./portfolio-health-index.component.html",
  styleUrls: ["./portfolio-health-index.component.scss"],
})
export class PortfolioHealthIndex {
  @Input() model_output?: PortfolioHealthData;
  @Input() simulation_output?: PortfolioHealthData;
  @Input() skuRecommendationVersion?: string = "V3";

  get skuTypes(): SKUType[] {
    return this.skuRecommendationVersion === "V3"
      ? ["Keep", "Accelerate", "Optimize", "Delist"]
      : ["Keep", "Grow", "DTP", "Delist"];
  }
  skuColors: Record<SKUType, string> = {
    Keep: "#6EBC14",
    Grow: "#E5B611",
    DTP: "#666666",
    Delist: "#D14447",
    Accelerate: "#E5B611",
    Optimize: "#666666",
  };

  getSkuColorCode(skuType: SKUType): string {
    return this.skuColors[skuType] || "#000";
  }
}
